export default {
  //apiUrl: "https://localhost:44372/api",
  //apiUrl: "http://localhost:91/api", //clon test
  //apiUrl: "https://uatapi.paratic.com.tr/api",
  //apiUrl: "https://ohvps-yonlendirme.octet.com.tr/api",
  apiUrl: "https://acikbankacilikapi.octet.com.tr/api", //Canlı      //MenuItems.js içindeki açık bankacılık payment modülü canlıda dbde 9 olduğundan 9 yapmalısın.
  //apiUrl: "https://ohvpstest-yonlendirme.octet.com.tr/api", //Test   //MenuItems.js içindeki açık bankacılık payment modülü test dbde 13 olduğundan 13 yapmalısın.
  headers: {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  },
  //demoUrl: "https://localhost:44351/",
  demoUrl: "https://acikbankacilik.octet.com.tr/", //Canlı
  //demoUrl: "https://test.finekra.com/", //Test
  //demoUrl: "https://www.finekra.com/",
  //frontEndUrl: "http://localhost:3000/",
  // frontEndUrl: "https://panel.paratic.com.tr/",
  //frontEndUrl: "https://ykb.finekra.com/",
  //frontEndUrl: "https://ohvpstest.octet.com.tr/",
  frontEndUrl: "https://acikbankacilik.octet.com.tr/", //Canlı
  //frontEndUrl: "https://ohvpstest.octet.com.tr/", //Test
  //frontEndUrl: "http://localhost:92/", //clon test
  //supportPanelImgUrl: "https://localhost:44391",
  supportPanelImgUrl: "https://acikbankacilikapi.octet.com.tr", //Canlı
  //supportPanelImgUrl: "https://ohvpstest-yonlendirme.octet.com.tr", //Test
  hideMenu: false,
  renderNotifications: false,
};
